import { Stage } from 'konva/lib/Stage';
import { useMapCanvas } from '../contexts/MapCanvasContext';
import { getWindowKonvaObject } from './konva/getWindowKonvaObject';

export function useZoomStageToScale() {
  const { stagePosition, updateStagePosition } = useMapCanvas();

  return (stage: Stage, newScale: number, animate = false) => {
    if (!stage) return;

    const stageWidth = stage.width();
    const stageHeight = stage.height();
    const centerX = stageWidth / 2;
    const centerY = stageHeight / 2;
    const pointTo = {
      x: (centerX - stagePosition.x) / stagePosition.scale,
      y: (centerY - stagePosition.y) / stagePosition.scale
    };

    stage.to({
      duration: animate ? 0.3 : 0,
      easing: animate ? getWindowKonvaObject().Easings.EaseInOut : undefined,
      scaleX: newScale,
      scaleY: newScale,
      x: centerX - pointTo.x * newScale,
      y: centerY - pointTo.y * newScale,
      onFinish: () => {
        updateStagePosition({
          scale: newScale,
          x: centerX - pointTo.x * newScale,
          y: centerY - pointTo.y * newScale
        });
      }
    });
  };
}
